import type { CSSProperties, ImgHTMLAttributes } from 'react';

/**
 * Lureo's logo: its artwork, or with the theme's logo-style 'shape' (data-logo="shape" on <html>) the artwork's shape in
 * the theme's brand ink (index.css .theme-logo).
 */
export function ThemedLogo({ src, className = '', style, ...rest }: ImgHTMLAttributes<HTMLImageElement> & { src: string }) {
  return <img src={src} className={`theme-logo ${className}`} style={{ ...style, '--lureo-logo-mask': `url(${src})` } as CSSProperties} {...rest} />;
}
